import { defineAgent } from '../agent-definition';
import { EVAL_AGENT_TYPE } from '../agent-types';

export const EVAL_AGENT = defineAgent({
  // A separate agent definition from the document page's: different record,
  // different brief, and only this one can stage a change. The user-facing name
  // below deliberately matches the document page's so those two read as one
  // assistant; the scope key is agent type + subject, so histories stay distinct.
  // The title workspace agent still shows its own name — unifying it is a
  // follow-up (see agents/insights-agents.test.ts).
  agentType: EVAL_AGENT_TYPE,
  agentName: 'Insights Agent',
  // Already leads with the product name, so the header must not prepend it again.
  prefixNameWithProduct: false,
  triggerLabel: 'Ask about this evaluation',
  inputPlaceholder: 'Ask where a number came from…',
  starters: [
    {
      title: 'What is this evaluation configured with?',
      prompt:
        'Walk me through how this run is configured: its effective date, volume and cost sources, and the case, price deck, type curve scenario and DCA scenario it used. Where a setting points at a record you cannot resolve, say so and give the id rather than describing it as unset.',
    },
    {
      title: 'What assumptions apply to each area?',
      prompt:
        'Show me the assumption assignments behind this run, area by area: which scenario is assigned for development pace, taxes, expenses, differentials, discount rates and royalty. Call out any domain where this run overrode what the case has saved, and any area where the assignments differ from the others.',
    },
    {
      title: 'What overrides is this run carrying?',
      prompt:
        'What per-slot overrides did this run carry — volume sources, AFE sources and cost dates, schedule dates, and any bulk entries? For bulk entries, tell me the filter the user selected with, not just how many slots it touched.',
    },
    {
      title: 'What changed since the last run?',
      prompt:
        'List the runs in this workspace, then compare the one I have open against the run before it: what settings, case assignments or slot overrides differ between them. Be explicit about which run each value came from.',
    },
  ],
  // No errorCopy: this endpoint emits no `reason` codes. Unlike the title
  // workspace, a run mid-calculation is not a reason to refuse — a run's
  // configuration is immutable once it starts (EvaluationCalculation::
  // IMMUTABLE_ATTRIBUTES), so it reads the same before and after the results
  // land. The prompt tells the agent not to describe outputs it does not have.
});
